import lodash from 'lodash';
import {getConfig, getEnv} from '../system/support/helpers';

export default {
    apiUrl: getConfig('API_URL', 'http://localhost:18000/api/v1'),
    soundUrl: lodash.trimEnd(getEnv('PUBLIC_URL'), '/') + '/',
    imageUrl: lodash.trimEnd(getEnv('PUBLIC_URL'), '/') + '/',
};
